import { getSavedFilters } from 'Services/api/savedFilters';
import { RESPONSE_STATUS } from 'Services/httpStatusChecker';
import { ERRORS } from 'Utilities/consts';
import { fetchWithExceptionLogger } from 'Utilities/error/fetchWithExceptionLogger';

const fetchSavedSearchesWithExceptionLogger = (context) =>
	fetchWithExceptionLogger({
		callback: getSavedFilters.bind(null, context),
		defaultReturn: {},
		errorMessage: ERRORS.UNABLE_TO_FETCH_INITIAL_SAVED_FILTERS,
		extra: { context },
		ignoredResponses: [RESPONSE_STATUS.client.forbidden, RESPONSE_STATUS.client.unprocessableEntity],
		isWarning: true,
	});

export default fetchSavedSearchesWithExceptionLogger;
